export default "__VITE_ASSET__5d54b884__"